import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommitteeUI } from '@src/models';

@Component({
  selector: 'new-list-item-committee',
  templateUrl: './list-item-committee.component.html',
  styleUrls: ['../styles/list-item.component.scss', './list-item-committee.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemCommitteeComponent {
  @Input() set item(data: CommitteeUI | undefined) {
    this.data = data;
  }

  @Input() selectedId?: string;
  @Input() loading?: boolean;

  data?: CommitteeUI;
}
